import styled from "styled-components";

export const RotationControlContainer = styled.section`
    position:absolute;
    bottom:-185px;
    width:500px;
    height:50px;
    display:flex;
    justify-content:space-evenly;

    button { 
        position:relative;
    }
`